import React from "react";
import { IoMdClose } from "react-icons/io";

const ProfileModal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-50"
        onClick={onClose}
      ></div>

      {/* Modal */}
      <div className="fixed inset-0 flex justify-center items-center z-50 p-4">
        <div className="bg-white rounded-lg shadow-lg w-full max-w-sm p-6 max-h-[90vh] overflow-y-auto" style={{ backgroundColor: "#ffffff" }}>
          <div className="flex justify-between items-center">
            <h2 className="text-[22px] font-bold" style={{ color: "#000000", margin: 0 }}>My Account Info</h2>
            <button
              className="px-2 py-1 bg-black text-white border-none rounded-lg hover:bg-gray-800 cursor-pointer"
              onClick={onClose}
            >
              <IoMdClose />
            </button>
          </div>
          <div className="mt-4" style={{ color: "#000000" }}>{children}</div>
        </div>
      </div>
    </>
  );
};

export default ProfileModal;
